import { motion } from "framer-motion";
import { EVENTS } from "@/data/content";
import { Reveal, SectionLabel } from "./Reveal";
import { scrollToId } from "@/lib/scroll";

export const Events = ({ onPick }) => {
  const pick = (kind) => { onPick(kind); scrollToId("enquire"); };
  return (
    <section id="parties" data-testid="parties-section" className="relative py-24 md:py-32 bg-[#0E101D]">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal>
          <SectionLabel color="text-[#FF2A85]">Events & parties</SectionLabel>
          <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-4xl">Your party.<br /><span className="text-stroke">Our playground.</span></h2>
        </Reveal>
        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {EVENTS.map((e, i) => (
            <motion.div
              key={e.kind}
              data-testid={`event-card-${e.kind}`}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className={`group ${i === 1 ? "md:mt-16" : ""}`}
            >
              <div className="relative aspect-[4/5] overflow-hidden rounded-t-[200px] rounded-b-[28px] border-[3px] border-black shadow-[8px_8px_0_#FF2A85]">
                <img src={e.img} alt={e.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-[1.2s] group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                <span className="absolute bottom-5 left-5 font-mono text-xs text-[#FFEF00]">0{i + 1}</span>
              </div>
              <h3 className="mt-6 font-display font-extrabold text-2xl">{e.title}</h3>
              <p className="mt-2 text-slate-300 text-sm md:text-base leading-relaxed">{e.copy}</p>
              <button data-testid={`event-enquire-${e.kind}`} onClick={() => pick(e.kind)} className="mt-5 btn-ghost rounded-full px-5 py-2.5 text-sm font-semibold">Enquire now →</button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
